// extracted by mini-css-extract-plugin
module.exports = {"icon":"SiDaHot_style_icon__YP9Ts"};